import React, { Component } from 'react';
import './App.css';
import {Switch, Route} from 'react-router-dom';
import Home from './components/Home';
import Slider from "./components/Slider";
import Musiques from "./components/Musiques";

class App extends Component {


	render()
	{
		return (
			<main>
				<Switch>
					<Route exact path='/' component={Home}/>
					<Route path='/musiques' component={Musiques}/>
					<Route path='/:book' component={Slider}/>
				</Switch>
			</main>
		);
	}
}

if((/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase())))
	document.body.classList.toggle('tablet');
else
	document.body.classList.toggle('pc');

export default App;


// WEBPACK FOOTER //
// ./src/App.js